module.exports = __webpack_public_path__ + "logo-orkla-tagline-dk-40323cb974fde20b63c2a406ac2756be.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-dk.svg
// module id = 62
// module chunks = 0